export default __webpack_public_path__ + "static/media/pause.5568f391.svg";